import { useQuery } from '@apollo/client';

import { MY_UNTINDERED_USERS } from '../graphql/query/myUntinderedUsersQuery.graphql';

export const useMyUntinderedUsersQuery = (eventId: string) => {
  return useQuery(MY_UNTINDERED_USERS, {
    variables: { eventId },
    fetchPolicy: 'network-only',
  });
};
